import { render, staticRenderFns } from "./ReferenceData.vue?vue&type=template&id=097cb30b&scoped=true"
import script from "./ReferenceData.vue?vue&type=script&lang=js"
export * from "./ReferenceData.vue?vue&type=script&lang=js"
import style0 from "./ReferenceData.vue?vue&type=style&index=0&id=097cb30b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097cb30b",
  null
  
)

export default component.exports